export function registerAutoComplete(inputSelector, api) {
    const attachedClass = ".js-autocomplete-attached";
    const inputField = document.querySelector(`${inputSelector}:not(${attachedClass})`);
    if (!inputField) {
        return;
    }
    let last_list = null;
    document.addEventListener("click", el => {
        closeAllLists(el.target);
    });
    function closeAllLists(elmnt = null) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inputField) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    var currentFocus = 0;
    inputField.addEventListener("input", event => {
        const target = event.currentTarget;
        const inp = target
            .parentElement
            .querySelector('input');
        var a, b, val = inp.value;
        /*close any already open lists of autocompleted values*/
        if (!val) {
            closeAllLists();
            return false;
        }
        if (val.length > 2 && val.length % 2 == 0) { }
        else {
            return false;
        }
        closeAllLists();
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", inp.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        inp.parentNode.appendChild(a);
        /*for each item in the array...*/
        api.searchProducts(val).then(function (data) {
            last_list = data.items;
            let index = 0;
            data.items.forEach(function (product) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                function get_desc(value) {
                    let desc = value.name;
                    if (value.content) {
                        desc += ` ${value.content}`;
                    }
                    return desc;
                }
                b.innerHTML = "<strong>" + get_desc(product) + "</strong>";
                // b.innerHTML += arr[i].substr(val.length);
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + index + "'>";
                index += 1;
                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function (e) {
                    /*insert the value for the autocomplete text field:*/
                    let hfield_value = this.getElementsByTagName("input")[0].value;
                    // inputField.value = this.getElementsByTagName("input")[0].value;
                    e.preventDefault();
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    closeAllLists();
                    window.location.href = '/product/' + last_list[hfield_value].slug;
                });
                a.appendChild(b);
            });
        });
    });
    /*execute a function presses a key on the keyboard:*/
    inputField.addEventListener("keydown", e => {
        const target = e.currentTarget;
        const inp = target
            .parentElement
            .querySelector('input');
        let x = document.getElementById(inp.id + "autocomplete-list");
        if (!x) {
            return;
        }
        let dList = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(dList);
        }
        else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(dList);
        }
        else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus >= 0) {
                window.location.href = '/product/' + last_list[currentFocus].slug;
                return;
            }
            inp.closest('form').submit();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                dList[currentFocus].click();
            }
        }
    });
    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x)
            return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length)
            currentFocus = 0;
        if (currentFocus < 0)
            currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }
}
